// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__yZXNz","checkbox__visible":"Checkbox_checkbox__visible__z4jDV","checkbox__label":"Checkbox_checkbox__label__hkHdd"};